// const ABViewManagerMobileCore = require("../core/ABViewManagerMobileCore");
// module.exports = class ABViewManagerMobile extends ABViewManagerMobileCore {};
module.exports = class ABViewManagerMobile {};
